import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

const getBrowserLang = (): string => {
  const lang = navigator.language || 'zh';
  if (lang.startsWith('zh')) return 'zh';
  if (lang.startsWith('en')) return 'en';
  return 'zh';
};

const savedLang = localStorage.getItem('glowpic_lang');
const initialLang = savedLang || getBrowserLang();

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: initialLang,
    fallbackLng: 'en',
    debug: false,
    resources: messages,
    detection: { order: [] },
    interpolation: {
      escapeValue: false,
    },
  });

export const changeLanguage = (lang: 'zh' | 'en') => {
  localStorage.setItem('glowpic_lang', lang);
  i18n.changeLanguage(lang);
};

export const getCurrentLang = (): 'zh' | 'en' => {
  return (i18n.language === 'zh' ? 'zh' : 'en') as 'zh' | 'en';
};

export default i18n;
